export default __webpack_public_path__ + "2257ad967e33d1b256d01c43f4874caf.svg";